// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Layout */
.messages-page-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: var(--gray-50);
}

.messages-main-content {
  flex: 1 1;
  padding: 2rem;
  margin-left: 250px; /* Adjust based on your sidebar width */
  transition: margin 0.3s ease;
}

/* Header */
.messages-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2rem;
}

.messages-title {
  display: flex;
  align-items: center;
  font-size: 1.8rem;
  color: var(--gray-800);
  margin: 0;
}

.messages-title-icon {
  margin-right: 0.8rem;
  color: var(--primary-400);
}

.messages-count-badge {
  background-color: var(--primary-400);
  color: white;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: 500;
}

/* Loading State */
.messages-loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
}

.messages-loading-spinner {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top: 4px solid var(--primary-400);
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Error State */
.messages-error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 60vh;
  text-align: center;
  padding: 2rem;
}

.messages-error-icon {
  background-color: var(--error);
  color: white;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.messages-retry-button {
  background-color: var(--primary-400);
  color: white;
  border: none;
  padding: 0.6rem 1.2rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1rem;
  margin-top: 1rem;
  transition: background-color 0.3s;
}

.messages-retry-button:hover {
  background-color: var(--primary-600);
}

/* Empty State */
.messages-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 50vh;
  text-align: center;
  color: var(--gray-500);
}

.messages-empty-icon {
  font-size: 3rem;
  color: #bdc3c7;
  margin-bottom: 1rem;
}

.messages-empty-state h3 {
  color: var(--gray-800);
  margin-bottom: 0.5rem;
}

/* Messages List */
.messages-list-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
  gap: 1.5rem;
}

.message-card {
  background-color: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  position: relative;
  overflow: hidden;
}

.message-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.message-unread {
  border-left: 4px solid var(--primary-400);
}

.message-read {
  opacity: 0.9;
}

.message-card-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.8rem;
}

.message-sender {
  font-weight: 600;
  color: var(--gray-800);
}

.message-to {
  font-weight: normal;
  color: var(--gray-500);
  font-size: 0.9rem;
  margin-left: 0.5rem;
}

.message-time {
  display: flex;
  align-items: center;
  color: #95a5a6;
  font-size: 0.85rem;
}

.message-time-icon {
  margin-right: 0.3rem;
  font-size: 0.9rem;
}

.message-subject {
  color: var(--gray-800);
  margin: 0.5rem 0 1rem;
  font-size: 1.1rem;
}

.message-preview {
  color: var(--gray-500);
  margin-bottom: 1rem;
  font-size: 0.95rem;
  line-height: 1.5;
}

.message-attachments {
  display: flex;
  align-items: center;
  color: var(--primary-400);
  font-size: 0.85rem;
  margin-bottom: 1rem;
}

.attachment-icon {
  margin-right: 0.4rem;
}

.message-read-more {
  display: flex;
  align-items: center;
  color: var(--primary-400);
  font-size: 0.9rem;
  font-weight: 500;
}

.read-more-icon {
  margin-left: 0.3rem;
  transition: transform 0.2s;
}

.message-card:hover .read-more-icon {
  transform: translateX(3px);
}

.message-unread-badge {
  position: absolute;
  top: 1rem;
  right: 1rem;
  width: 10px;
  height: 10px;
  background-color: var(--primary-400);
  border-radius: 50%;
}

/* Responsive Design */
@media (max-width: 992px) {
  .messages-main-content {
    margin-left: 0;
    padding: 1.5rem;
  }

  .messages-list-container {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 768px) {
  .messages-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .messages-count-badge {
    margin-top: 0.5rem;
  }

  .message-card {
    padding: 1.2rem;
  }
}

@media (max-width: 480px) {
  .messages-main-content {
    padding: 1rem;
  }

  .message-card-header {
    flex-direction: column;
  }

  .message-time {
    margin-top: 0.3rem;
    align-self: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Messages/MyMessages.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB,EAAE,uCAAuC;EAC3D,4BAA4B;AAC9B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,0CAA0C;EAC1C,eAAe;EACf,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF","sourcesContent":["/* Main Layout */\n.messages-page-container {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background-color: var(--gray-50);\n}\n\n.messages-main-content {\n  flex: 1;\n  padding: 2rem;\n  margin-left: 250px; /* Adjust based on your sidebar width */\n  transition: margin 0.3s ease;\n}\n\n/* Header */\n.messages-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 2rem;\n}\n\n.messages-title {\n  display: flex;\n  align-items: center;\n  font-size: 1.8rem;\n  color: var(--gray-800);\n  margin: 0;\n}\n\n.messages-title-icon {\n  margin-right: 0.8rem;\n  color: var(--primary-400);\n}\n\n.messages-count-badge {\n  background-color: var(--primary-400);\n  color: white;\n  padding: 0.3rem 0.8rem;\n  border-radius: 20px;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n/* Loading State */\n.messages-loading-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 60vh;\n}\n\n.messages-loading-spinner {\n  border: 4px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top: 4px solid var(--primary-400);\n  width: 40px;\n  height: 40px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Error State */\n.messages-error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 60vh;\n  text-align: center;\n  padding: 2rem;\n}\n\n.messages-error-icon {\n  background-color: var(--error);\n  color: white;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.8rem;\n  font-weight: bold;\n  margin-bottom: 1rem;\n}\n\n.messages-retry-button {\n  background-color: var(--primary-400);\n  color: white;\n  border: none;\n  padding: 0.6rem 1.2rem;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 1rem;\n  margin-top: 1rem;\n  transition: background-color 0.3s;\n}\n\n.messages-retry-button:hover {\n  background-color: var(--primary-600);\n}\n\n/* Empty State */\n.messages-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 50vh;\n  text-align: center;\n  color: var(--gray-500);\n}\n\n.messages-empty-icon {\n  font-size: 3rem;\n  color: #bdc3c7;\n  margin-bottom: 1rem;\n}\n\n.messages-empty-state h3 {\n  color: var(--gray-800);\n  margin-bottom: 0.5rem;\n}\n\n/* Messages List */\n.messages-list-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));\n  gap: 1.5rem;\n}\n\n.message-card {\n  background-color: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n  transition: transform 0.2s, box-shadow 0.2s;\n  position: relative;\n  overflow: hidden;\n}\n\n.message-card:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n\n.message-unread {\n  border-left: 4px solid var(--primary-400);\n}\n\n.message-read {\n  opacity: 0.9;\n}\n\n.message-card-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 0.8rem;\n}\n\n.message-sender {\n  font-weight: 600;\n  color: var(--gray-800);\n}\n\n.message-to {\n  font-weight: normal;\n  color: var(--gray-500);\n  font-size: 0.9rem;\n  margin-left: 0.5rem;\n}\n\n.message-time {\n  display: flex;\n  align-items: center;\n  color: #95a5a6;\n  font-size: 0.85rem;\n}\n\n.message-time-icon {\n  margin-right: 0.3rem;\n  font-size: 0.9rem;\n}\n\n.message-subject {\n  color: var(--gray-800);\n  margin: 0.5rem 0 1rem;\n  font-size: 1.1rem;\n}\n\n.message-preview {\n  color: var(--gray-500);\n  margin-bottom: 1rem;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.message-attachments {\n  display: flex;\n  align-items: center;\n  color: var(--primary-400);\n  font-size: 0.85rem;\n  margin-bottom: 1rem;\n}\n\n.attachment-icon {\n  margin-right: 0.4rem;\n}\n\n.message-read-more {\n  display: flex;\n  align-items: center;\n  color: var(--primary-400);\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.read-more-icon {\n  margin-left: 0.3rem;\n  transition: transform 0.2s;\n}\n\n.message-card:hover .read-more-icon {\n  transform: translateX(3px);\n}\n\n.message-unread-badge {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  width: 10px;\n  height: 10px;\n  background-color: var(--primary-400);\n  border-radius: 50%;\n}\n\n/* Responsive Design */\n@media (max-width: 992px) {\n  .messages-main-content {\n    margin-left: 0;\n    padding: 1.5rem;\n  }\n\n  .messages-list-container {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 768px) {\n  .messages-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .messages-count-badge {\n    margin-top: 0.5rem;\n  }\n\n  .message-card {\n    padding: 1.2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .messages-main-content {\n    padding: 1rem;\n  }\n\n  .message-card-header {\n    flex-direction: column;\n  }\n\n  .message-time {\n    margin-top: 0.3rem;\n    align-self: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
